import { type PropsWithChildren, createContext, useContext, useEffect, useMemo } from 'react'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { ConversionDetailsStore } from '../store/conversionDetailsStore'

const ConversionDetailsContext = createContext<ConversionDetailsStore | null>(null)

export const useConversionDetailsContext = () => {
  const context = useContext(ConversionDetailsContext)

  if (context === null)
    throw new Error('You have forgotten to wrap your root component with ConversionDetailsProvider')

  return context
}

interface ConversionDetailsProviderProps extends PropsWithChildren {
  conversionId: number
}

export const ConversionDetailsProvider = ({
  children,
  conversionId,
}: ConversionDetailsProviderProps) => {
  const entities = useEntitiesContext()
  const store = useMemo(() => new ConversionDetailsStore(entities), [])

  useEffect(() => {
    void store.init(conversionId)

    return () => {
      store.dispose()
    }
  }, [conversionId])

  return (
    <ConversionDetailsContext.Provider value={store}>{children}</ConversionDetailsContext.Provider>
  )
}
